import React from 'react';
import { CheckCircle } from 'lucide-react';
export function CandidateReport() {
  const reportFeatures = ['Overall score and pass/fail result', 'Breakdown by topic (Routing, Eloquent, Controllers, Blade, etc.)', 'Time spent per section and accuracy rate', 'Insights on strengths and areas for improvement'];
  return <section className="py-12 md:py-20 bg-white border-t border-gray-100" data-id="element-36">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-37">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16" data-id="element-38">
          <div className="lg:w-1/2" data-id="element-39">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6" data-id="element-40">
              What's Included in the Candidate Report?
            </h2>
            <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8" data-id="element-41">
              You receive a detailed, auto-graded report showing your
              candidate's performance across key Laravel skills — instantly
              after they complete the test.
            </p>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 font-medium" data-id="element-42">
              The report includes:
            </p>
            <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-43">
              {reportFeatures.map((feature, index) => <li key={index} className="flex items-start" data-id="element-44">
                  <CheckCircle size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-45" />
                  <span className="text-sm sm:text-base" data-id="element-46">{feature}</span>
                </li>)}
            </ul>
            <p className="text-sm sm:text-base text-gray-600" data-id="element-47">
              This gives you a clear, objective view of your candidate's real
              Laravel knowledge before making a hiring decision.
            </p>
          </div>
          <div className="lg:w-1/2 w-full" data-id="element-48">
            <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200" data-id="element-49">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1LZRpfP7SxAFGyXphubBmb/Schermafbeelding_2025-10-13_170351.png" alt="Sample candidate report showing Laravel skills assessment" className="w-full h-auto" data-id="element-50" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}